<template lang="pug">
p Card Message
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
